"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityDisplay = void 0;
var React = require("react");
function CausalityDisplay(props) {
    var prefix = props.causality.is_cause ? get_term("Cause") : get_term("Effect");
    var text = props.causality.text;
    var cropped = false;
    if (props.maxTextLength && text.length > props.maxTextLength) {
        text = text.substring(0, props.maxTextLength) + "...";
        cropped = true;
    }
    return (React.createElement("span", { title: cropped ? props.causality.text : null },
        React.createElement("span", { className: "DomainItemBox DomainItemBox--causality" },
            prefix,
            " #",
            props.causality.number),
        " ",
        text));
}
exports.CausalityDisplay = CausalityDisplay;
